import React from 'react';
import Skeleton from '../../Shared/Skeleton/Skeleton';

function ComponentFormSkeleton() {
    return (
        <Skeleton
            rows={[
                {
                    columns: [
                        { size: 10 },
                        { size: 2 }
                    ]
                },
                { full: true }
            ]} />
    )
}

export default ComponentFormSkeleton;